import React from 'react';

import { angularizeWithProviders } from '../../../shared/providers';
import { CustomerPasswordBlock } from '../../components/CustomerPasswordBlock/CustomerPasswordBlock';

type NgzCustomerPasswordTabProps = {
  userId: number;
};

const NgzCustomerPasswordTab = ({ userId }: NgzCustomerPasswordTabProps) => {
  return userId ? <CustomerPasswordBlock userId={userId} /> : null;
};

angularizeWithProviders(NgzCustomerPasswordTab, 'ngzCustomerPasswordTab', {
  userId: '<',
});
